import { render, staticRenderFns } from "./EditTeamMembers.vue?vue&type=template&id=a6bc0b6c&scoped=true"
import script from "./EditTeamMembers.vue?vue&type=script&lang=js"
export * from "./EditTeamMembers.vue?vue&type=script&lang=js"
import style0 from "./EditTeamMembers.vue?vue&type=style&index=0&id=a6bc0b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bc0b6c",
  null
  
)

export default component.exports